import { HTTP } from '@/services/axios';

export async function getCategories({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/LibraryCategory/getLibraryCategoriesList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getCategory({categoryId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/LibraryCategory/getLibraryCategoryData.php?categoryId=${categoryId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}

export async function getCategoryOptions(){
    let result = [];
    
    await HTTP.get('/app/core/LibraryCategory/getLibraryCategoryOptions.php',{})
    .then(response => {
        result = response.data.result;  
    })
        .catch(function (error) {
        console.log(error);
    });

    return result;
}

export async function unlockCategory({categoryId}){
    let result = {};

    var data = {'myRecordID':categoryId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/LibraryCategory/controlLibraryCategoryUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function changeStateCategory({recordId,state}){
    let result = {};

    var data = {'recordId':recordId,'state':state};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/LibraryCategory/controlLibraryCategoryChangeState.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createCategory({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/LibraryCategory/controlLibraryCategorySave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveCategory({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/LibraryCategory/controlLibraryCategorySave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteCategory({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/LibraryCategory/controlLibraryCategoryDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}